var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 13C4 12.4477 4.44772 12 5 12H5.01C5.56228 12 6.01 12.4477 6.01 13C6.01 13.5523 5.56228 14 5.01 14H5C4.44772 14 4 13.5523 4 13Z",
    fill: "#2E2C71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13C8 12.4477 8.44771 12 9 12H9.01C9.56228 12 10.01 12.4477 10.01 13C10.01 13.5523 9.56228 14 9.01 14H9C8.44771 14 8 13.5523 8 13Z",
    fill: "#2E2C71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10C21.5523 10 22 9.55228 22 9L21.9998 8.97892C21.9967 8.83072 21.9606 8.68497 21.8942 8.55227L21.8852 8.53428C21.8422 8.45275 21.7883 8.37788 21.7254 8.31162C21.6261 8.20705 21.5044 8.12393 21.3681 8.06992C21.2542 8.0248 21.13 8 21 8H19.3809L20 9.23637V10H21Z",
    fill: "#2E2C71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9C0 8.83184 0.0415083 8.67337 0.114838 8.53428C0.28234 8.21658 0.615878 8 1 8H2.61909H19.3809L20 9.23637V10H2V15C2 15.2652 2.10536 15.5196 2.29289 15.7071C2.48043 15.8946 2.73478 16 3 16H19C19.2652 16 19.5196 15.8946 19.7071 15.7071C19.8946 15.5196 20 15.2652 20 15V10H21C21.5523 10 22 9.55228 22 9V15C22 15.7957 21.6839 16.5587 21.1213 17.1213C20.5587 17.6839 19.7957 18 19 18H3C2.20435 18 1.44129 17.6839 0.87868 17.1213C0.31607 16.5587 0 15.7956 0 15V9ZM21.3681 8.06992L21.9998 8.97892C21.9967 8.83072 21.9606 8.68497 21.8942 8.55227L21.8852 8.53428L21.7254 8.31162C21.6261 8.20705 21.5044 8.12393 21.3681 8.06992Z",
    fill: "#2E2C71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.76 1.19209e-07L6.24 0C5.68187 0.000296175 5.13437 0.156283 4.66004 0.45042C4.18617 0.74427 3.80358 1.16436 3.5552 1.66354C3.55495 1.66403 3.55471 1.66451 3.55447 1.665L0.114838 8.53428C0.28234 8.21658 0.615878 8 1 8H2.61909L5.34417 2.55773L5.34553 2.555C5.42832 2.38839 5.55594 2.24819 5.71405 2.15014C5.87211 2.05213 6.05436 2.00013 6.24034 2H15.7597C15.9456 2.00013 16.1279 2.05213 16.2859 2.15014C16.4441 2.24818 16.5717 2.38839 16.6545 2.555L16.6558 2.55773L19.3809 8H21C21.13 8 21.2542 8.0248 21.3681 8.06992C21.5044 8.12393 21.6261 8.20705 21.7254 8.31162C21.7883 8.37788 21.8422 8.45275 21.8852 8.53428L18.4455 1.665C18.4453 1.66456 18.4451 1.66412 18.4449 1.66368C18.1965 1.16444 17.8139 0.744298 17.34 0.45042C16.8656 0.156283 16.3181 0.000296414 15.76 1.19209e-07Z",
    fill: "#2E2C71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessor);
export default __webpack_public_path__ + "static/media/processor.60a651ad9e36b6a012fa315377e43cb8.svg";
export { ForwardRef as ReactComponent };